module.exports = __webpack_public_path__ + "static/media/img-grow-product-2.385a29b2.png";